<div class="grid">
  <div class="col-12">
    <div class="card">
      <h5 translate>DELIVERY_NOTES.DELIVERY_NOTES</h5>
      <p-table #dt
               [value]="deliveryNotes"
               [lazy]="true"
               (onLazyLoad)="pageChanged($event)"
               [(selection)]="selectedDeliveryNote"
               dataKey="id"
               [rowHover]="true"
               [rows]="filter.limit"
               [totalRecords]="(count$ | async) || 0"
               [showCurrentPageReport]="true"
               [rowsPerPageOptions]="[10,15,20,50,200]"
               [loading]="loading"
               [paginator]="true"
               sortField="dateCreated"
               [sortOrder]="-1"
               currentPageReportTemplate="{{'TABLE.SHOWING' | translate}}"
               [filterDelay]="0"
               [globalFilterFields]="['deliveryNote.number', 'dateCreated', 'buyer.name']">
        <ng-template pTemplate="caption">
          <div class="flex flex-column sm:flex-row sm:align-items-center sm:justify-content-between gap-3 table-header delivery-notes-table-header">
            <span class="p-input-icon-left delivery-notes-table-action">
              <p-button icon="pi pi-plus" class="p-button-raised w-full" (click)="openModal(null, null)"
                      [label]="'DELIVERY_NOTES.CREATE_DELIVERY_NOTE' | translate"></p-button>
            </span>
            <p-iconfield class="table-search ml-auto delivery-notes-table-search" iconPosition="left">
              <p-inputicon>
                <i class="pi pi-search"></i>
              </p-inputicon>
              <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                     placeholder="{{'TABLE.GLOBAL_SEARCH' | translate}}" class="w-full"/>
            </p-iconfield>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="number">
              <div class="flex justify-content-between align-items-center" translate>
                OFFERS.NUMBER
                <p-sortIcon field="number"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="buyer.name">
              <div class="flex justify-content-between align-items-center" translate>
                OFFERS.CUSTOMER
                <p-sortIcon field="buyer.name"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="createdBy">
              <div class="flex justify-content-between align-items-center" translate>
                OFFERS.CREATED_BY
                <p-sortIcon field="createdBy"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="project.name">
              <div class="flex justify-content-between align-items-center" translate>
                OFFER.PROJECT
                <p-sortIcon field="project.name"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="dateCreated">
              <div class="flex justify-content-between align-items-center" translate>
                OFFERS.DATE_CREATED
                <p-sortIcon field="dateCreated"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="dateValid">
              <div class="flex justify-content-between align-items-center" translate>
                OFFERS.DATE_ISSUED
                <p-sortIcon field="dateValid"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="dateDelivery">
              <div class="flex justify-content-between align-items-center" translate>
                OFFERS.DATE_DELIVERY
                <p-sortIcon field="dateDelivery"></p-sortIcon>
              </div>
            </th>
            <th style="width: 6.5rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-deliveryNote>
          <tr class="p-row">
            <td (click)="viewDeliveryNote(deliveryNote.id)" style="cursor: pointer;">
              {{deliveryNote.number}}
            </td>
            <td (click)="viewCustomer(deliveryNote.buyer.id)" style="cursor: pointer;">
              {{deliveryNote.buyer?.name}}
            </td>
            <td>
              {{deliveryNote.createdBy}}
            </td>
            <td>
              {{deliveryNote.project?.name}}
            </td>
            <td>
              {{deliveryNote.dateCreated | date: 'dd.MM.yyyy'}}
            </td>
            <td>
              {{deliveryNote.dateValid | date: 'dd.MM.yyyy'}}
            </td>
            <td>
              {{deliveryNote.dateDelivery | date: 'dd.MM.yyyy'}}
            </td>
            <td>
              <button pButton type="button" class="p-button-label table-button mr-2" icon="pi pi-pencil"
                      *ngIf="auth.isOwner(deliveryNote) || auth.isAdmin()"
                      (click)="openModal(null, deliveryNote)"></button>
              <button pButton type="button" class="p-button-danger table-button" icon="pi pi-trash"
                      *ngIf="auth.isOwner(deliveryNote) || auth.isAdmin()"
                      (click)="delete(deliveryNote)"></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8" translate>DELIVERY_NOTES.NO_DELIVERY_NOTES_FOUND</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>


